import React, { useState, useRef } from 'react';

import M from 'materialize-css';
import { WebService } from '../../services/webService';


const WhatsAppMsj = () => {
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('Seleccionar archivo Excel (.xlsx, .xls)');
    const [loading, setLoading] = useState(false);
    const [resultado, setResultado] = useState(null);
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFileName(selectedFile.name);
            setResultado(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            M.toast({ html: 'Por favor, selecciona un archivo Excel.', classes: 'orange darken-2' });
            return;
        }

        const formData = new FormData();
        formData.append('excel_file', file);

        setLoading(true);
        setResultado(null);

        try {
            const data = await WebService.enviarWhatsAppMasivo(formData);

            if (data.status === 'success') {
                M.toast({ html: data.message || '¡Mensajes enviados con éxito!', classes: 'green darken-2' });
                setResultado(data.data);
            }
        } catch (error) {
            console.error(error);
            const errorMsg = error.response?.data?.message || error.message || 'Ocurrió un error al enviar los mensajes.';
            M.toast({ html: errorMsg, classes: 'red darken-2' });
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setFile(null);
        setFileName('Seleccionar archivo Excel (.xlsx, .xls)');
        setResultado(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div className="container" style={{ marginTop: '40px' }}>
            <div className="row">
                <div className="col s12 m8 offset-m2">
                    <div className="card">
                        <div className="card-content">
                            <span className="card-title green-text text-darken-2">
                                <i className="material-icons left">chat</i>
                                Envío Masivo de WhatsApp por Excel
                            </span>
                            <p className="grey-text text-darken-1" style={{ marginBottom: '20px' }}>
                                Sube el archivo Excel. El sistema tomará los números de destino desde la <b>Columna D</b>.
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div className="file-field input-field">
                                    <div className="btn green darken-1">
                                        <span>Examinar</span>
                                        <input 
                                            type="file" 
                                            ref={fileInputRef}
                                            accept=".xlsx, .xls" 
                                            onChange={handleFileChange} 
                                        />
                                    </div>
                                    <div className="file-path-wrapper">
                                        <input 
                                            className="file-path validate" 
                                            type="text" 
                                            value={fileName} 
                                            readOnly 
                                        />
                                    </div>
                                </div>

                                <div className="form-actions" style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                                    <button 
                                        type="submit" 
                                        className={`btn waves-effect waves-light green darken-2 ${loading ? 'disabled' : ''}`}
                                        disabled={loading || !file}
                                    >
                                        {loading ? 'Enviando mensajes...' : 'Iniciar Envio Masivo'}
                                        <i className="material-icons right">send</i>
                                    </button>

                                    {file && !loading && (
                                        <button 
                                            type="button" 
                                            onClick={handleReset} 
                                            className="btn waves-effect waves-light grey lighten-1 black-text"
                                        >
                                            Cancelar
                                        </button>
                                    )}
                                </div>
                            </form>

                            {loading && (
                                <div className="progress green lighten-4" style={{ marginTop: '25px' }}>
                                    <div className="indeterminate green darken-2"></div>
                                </div>
                            )}

                            {resultado && (
                                <div className="card-panel grey lighten-4" style={{ marginTop: '30px' }}>
                                    <h6 className="green-text text-darken-2" style={{ fontWeight: 'bold' }}>
                                        <i className="material-icons left" style={{ fontSize: '20px' }}>assessment</i>
                                        Resumen de Envíos:
                                    </h6>
                                    <ul className="collection" style={{ border: 'none', margin: '10px 0 0 0' }}>
                                        <li className="collection-item grey lighten-4" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span>Mensajes enviados con éxito:</span>
                                            <span className="new badge green" data-badge-caption="">{resultado.enviados}</span>
                                        </li>
                                        <li className="collection-item grey lighten-4" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span>Envíos fallidos:</span>
                                            <span className="new badge red" data-badge-caption="">{resultado.fallidos}</span>
                                        </li>
                                        <li className="collection-item grey lighten-4" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span>Filas saltadas (vacías):</span>
                                            <span className="new badge orange" data-badge-caption="">{resultado.saltados}</span>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatsAppMsj;